import {Model} from '@vuex-orm/core'
import {Ligne} from './Ligne'

export class Entete extends Model {
  static entity = 'Entete'

  static fields () {
    return {
      id: this.number(null),
      domaine: this.string(''),
      numeroDocument: this.string(''),
      dateHeureDebut: this.string(''),
      dateHeureFin: this.string(''),
      typeDocument: this.string(''),
      softId: this.number(null),
      ligne_retro_id: this.number(null),
      lignes: this.hasMany(Ligne, 'entete_id')
    }
  }

  static fetchEntetes ($depotVente, $deposant) {
    return this.api().get('/deposant/' + $depotVente + '/' + $deposant + '/entetes');
  }
}
